/** Install separately from meta-funnel.js, after campaign clearance. */
const script = document.currentScript as HTMLScriptElement | null;
const app = script ? new URL(script.src).searchParams.get('app-id') : null;
const allowed = ['6970944fa1489d567d4506bc', '69c9084860c0cc01293b10be'];
type PopupRuntime = { init: (config: { app: string; visible: boolean; popupOnly: boolean }) => Promise<void> };
const host = window as Window & { LoyaltyStation?: PopupRuntime; gamiphyAsyncInit?: (sdk: PopupRuntime) => void; __icbPopupLoaded?: boolean };
if (app && allowed.includes(app) && !host.__icbPopupLoaded) {
  host.__icbPopupLoaded = true;
  const initialize = () => { void host.LoyaltyStation?.init({ app, visible: false, popupOnly: true }); };
  if (host.LoyaltyStation) initialize();
  else {
    const previous = host.gamiphyAsyncInit;
    host.gamiphyAsyncInit = (sdk) => {
      // Claim the first startup before a host callback can request the full SDK.
      initialize();
      previous?.(sdk);
    };
    const runtime = document.createElement('script');
    // This responsive desktop runtime includes both desktop and touch watchers.
    runtime.src = new URL('../../desktop/main.bundle.js', script!.src).href;
    runtime.async = true;
    document.head.appendChild(runtime);
  }
}
export {};
